import { Component, Inject, LOCALE_ID, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import DataSource from 'devextreme/data/data_source';
import { DxFormComponent } from 'devextreme-angular';
import { RestApiService } from '../../shared/services/rest-api.service';
import { ToolbarService } from '../../shared/services/toolbar.service';
import { WorkerAndToolService } from '../../shared/services/worker-and-tool.service';
import { confirm } from 'devextreme/ui/dialog';
import { HoursOption } from '../../shared/models/hours-option';
import { Clock } from '../../shared/models/clock';
import { Worker } from '../../shared/models/worker';
import { first, Subject, takeUntil } from 'rxjs';
import { APIKey, MapMarker } from '../../shared/models/map-marker';
import { formatDate } from '@angular/common';



import Map from 'ol/Map';
import View from 'ol/View';
//import TileLayer from 'ol/layer/Tile';
//import OSM from 'ol/source/OSM';
import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import VectorSource from 'ol/source/Vector';
import VectorLayer from 'ol/layer/Vector';
import Group from 'ol/layer/Group';
import Overlay from 'ol/Overlay';
import { Style, Icon } from 'ol/style';
import { fromLonLat } from 'ol/proj';

import XYZ from 'ol/source/XYZ';
import { apply } from 'ol-mapbox-style';



interface MarkersInfo {
  lat: number;
  lng: number;
  descr: string;
}


@Component({
    selector: 'app-clock-admin',
    templateUrl: './clock-admin.component.html',
    styleUrls: ['./clock-admin.component.scss'],
    standalone: false
})
export class ClockAdminComponent {
  @ViewChild(DxFormComponent, { static: false }) form!: DxFormComponent;

  private unsubscribe: Subject<void> = new Subject<void>();

  private direzioni = [
    { ID: 'E', Descrizione: 'Entrata' },
    { ID: 'U', Descrizione: 'Uscita' }
  ];

  constructionSitesStore: DataSource;
  constructionPhasesStore: DataSource;
  workersStore: DataSource;

  option: HoursOption | undefined;
  clock: Clock;
  clockId: number | null = null;


    // old map
  markers: MapMarker[] = [];

  apiKey: APIKey = {
    azure: "ChfbRnQ9Q26640aewm0WMyuswqe74umqdOTQ2LxSQhhd7PEe5hN4JQQJ99BJAC5RqLJ7BGfpAAAgAZMP4egU"
  };
  //---------//



  map!: Map;
  private vectorSource!: VectorSource;
  private overlay!: Overlay;
  public locationData: MarkersInfo[] = [];

  priorities = [
    'Terrestre',
    'Satellitare',
  ];


  currentPriority: string = this.priorities[0];
  satellitare: boolean = this.currentPriority === 'Satellitare';
  
  onPriorityChange(e: any): void {
    this.currentPriority = e.value;
    this.updateMapVisibility();
  }

  updateMapVisibility(): void {
    this.satellitare = this.currentPriority === 'Satellitare';
  }



  notesEditorOptions: unknown;
  dataRegistrazioneEditorOptions: unknown;
  cantiereEditorOptions: unknown;
  faseEditorOptions: unknown;
  workerEditorOptions: unknown;
  directionEditorOptions: unknown;

  constructor(
    @Inject(LOCALE_ID) public locale: string,
    private service: WorkerAndToolService,
    private restApi: RestApiService,
    private toolbar: ToolbarService,
    private route: ActivatedRoute,
    private router: Router) {

    let tenantId = localStorage.getItem("tenantId");
    tenantId ??= "0";

    this.clock = {
      clockId: 0,
      tenantID: +tenantId,
      deviceDate: new Date(),
      utcDeviceDate: new Date().toISOString(),
      manual: false,
      notes: "",
      constructionSiteCode: "",
      workerNumber: "",
      direction: ""
    };

    this.dataRegistrazioneEditorOptions = {
      displayFormat: "dd/MM/yyyy HH:mm",
      dateSerializationFormat: "yyyy-MM-ddTHH:mm:ssZ",
      type: "datetime",
    };

    this.constructionSitesStore = this.restApi.getConstructionSitesDataSorce();

    this.cantiereEditorOptions = {
      dataSource: this.constructionSitesStore,
      searchEnabled: true,
      displayExpr: "constructionSiteDescription",
      valueExpr: "constructionSiteCode",
      showClearButton: true,
      searchExpr: "constructionSiteDescription",
      searchMode: "contains",
      usePopover: false,
      wrapItemText: true,
      placeholder: "Selezionare il cantiere",
      dropDownOptions: {
        fullScreen: true,
        showTitle: false
      }
    };

    this.constructionPhasesStore = this.restApi.getConstructionPhasesDataSorce();

    this.faseEditorOptions = {
      dataSource: this.constructionPhasesStore,
      searchEnabled: true,
      displayExpr: "constructionSiteDescription",
      valueExpr: "constructionSiteCode",
      showClearButton: true,
      searchExpr: "constructionSiteDescription",
      searchMode: "contains",
      usePopover: false,
      wrapItemText: true,
      placeholder: "Selezionare la fase",
      dropDownOptions: {
        fullScreen: true,
        showTitle: false
      }
    };

    this.workersStore = this.restApi.getWorkersDataSorce();

    this.workerEditorOptions = {
      dataSource: this.workersStore,
      searchEnabled: true,
      displayExpr: "description",
      valueExpr: "workerNumber",
      showClearButton: true,
      searchExpr: "description",
      searchMode: "contains",
      usePopover: false,
      wrapItemText: true,
      placeholder: "Selezionare il dipendente",
      dropDownOptions: {
        fullScreen: true,
        showTitle: false
      }
    };

    this.directionEditorOptions = {
      dataSource: this.direzioni,
      displayExpr: "Descrizione",
      valueExpr: "ID",

    }
  }


  ngOnInit() {
    this.service.getHoursOptionObservable().pipe(takeUntil(this.unsubscribe)).subscribe(val => { this.option = val; });
    this.toolbar.backClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.Back());
    this.toolbar.forwardClickedEvent.pipe(takeUntil(this.unsubscribe)).subscribe(() => this.Forward());
   
    this.toolbar.BackVisibleChanged(false);
    this.toolbar.SaveVisibleChanged(true);
    this.toolbar.ForwardVisibleChanged(false);
    this.toolbar.CancelVisibleChanged(true);
    this.toolbar.PlusVisibleChanged(false);
    this.toolbar.EditVisibleChanged(false);
    this.toolbar.DeleteVisibleChanged(false);
    this.toolbar.CopyVisibleChanged(false);
    this.toolbar.MenuVisibleChanged(false);


    this.vectorSource = new VectorSource();


    const regId = this.route.snapshot.paramMap.get('id');
    if (regId != null) this.clockId = +regId;

    if (this.clockId == null) {
      this.toolbar.TitleChanged("Nuova Timbratura");
    }
    else {
      this.toolbar.TitleChanged("Modifica Timbratura");

      this.restApi.getClock(this.clockId).pipe(takeUntil(this.unsubscribe)).subscribe((clk) => {
        this.clock = clk;

        if (clk.latitudine && clk.longitudine) {
          let clockDate = clk.gpsDate;
          if (!clockDate) clockDate = clk.deviceDate;
          let direction = clk.direction;
          if (!direction) direction = '';


          //-- old map
          const clkMarker = new MapMarker(clk.latitudine, clk.longitudine, 'Timbratura (' + direction + ') ' + formatDate(clockDate, 'HH:mm', this.locale));
          this.markers.push(clkMarker);
          //----//



          this.locationData.push({ lat: clk.latitudine, lng: clk.longitudine, descr: 'Timbratura (' + direction + ') ' + formatDate(clockDate, 'HH:mm', this.locale) })

          const feat = new Feature({
            geometry: new Point(fromLonLat([clk.longitudine, clk.latitudine])),
            descr: 'Timbratura (' + direction + ') ' + formatDate(clockDate, 'HH:mm', this.locale)
          });
          feat.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                crossOrigin: 'anonymous',
                src: '/assets/clock-marker.png',
              })
            })
          );
          this.vectorSource.addFeature(feat);


        }

        if (clk.latitudineCantiere && clk.longitudineCantiere && clk.descrizioneCantiere) {


            // old map
          const clkCantiereMarker = new MapMarker(clk.latitudineCantiere, clk.longitudineCantiere, clk.descrizioneCantiere);
          clkCantiereMarker.iconSrc = '/assets/construction-marker.png';
          this.markers.push(clkCantiereMarker);
           //---------//


          const feat = new Feature({
            geometry: new Point(fromLonLat([clk.longitudineCantiere, clk.latitudineCantiere])),
            descr: clk.descrizioneCantiere
          });
          feat.setStyle(
            new Style({
              image: new Icon({
                anchor: [0.5, 1],
                crossOrigin: 'anonymous',
                src: '/assets/construction-marker.png',
              })
            })
          );
          this.vectorSource.addFeature(feat);
        }

        // popup overlay (cerca gli elementi nel template)
        const container = document.getElementById('popup') as HTMLElement;
        const content = document.getElementById('popup-content') as HTMLElement;
        const closer = document.getElementById('popup-closer') as HTMLElement;

        // per i messaggi popup ? 
        this.overlay = new Overlay({
          element: container!,
          autoPan: { animation: { duration: 250 } }
        });

        // chiudi popup
        if (closer) {
          closer.onclick = () => {
            this.overlay.setPosition(undefined);
            closer.blur();
            return false;
          };
        }

        const openfreemap = new Group();

        // crea la mappa
        this.map = new Map({
          target: 'ol-map',
          layers: [openfreemap],  //[baseLayer, vectorLayer],
          view: new View({
            center: fromLonLat([12.57, 44.06]), // valore temporaneo, verrà adattato
            zoom: 13,
            maxZoom: 22,
          }),
          overlays: [this.overlay]
        });

        // click su mappa: mostra popup se feature sotto il click
        this.map.on('singleclick', (evt) => {
          const feature = this.map.forEachFeatureAtPixel(evt.pixel, (f) => f);

          if (feature) {
            const geometry = feature.getGeometry();
            if (geometry && geometry.getType() === 'Point') {
              //const coords = (feature.getGeometry() as Point).getCoordinates();
              const coords = (geometry as Point).getCoordinates();
              const descr = feature.get('descr') || 'Nessuna descrizione';
              if (content) content.innerHTML = descr;
              this.overlay.setPosition(coords);
            } else {
              this.overlay.setPosition(undefined);
            }
          }
        });


        apply(this.map, 'https://tiles.openfreemap.org/styles/liberty')
          .then(() => {
            const vectorLayer = new VectorLayer({
              source: this.vectorSource,
              // non passare 'map' qui, aggiungilo con addLayer per essere sicuro
            });
            this.map.addLayer(vectorLayer);

            // fit automatico se ci sono marker
            if (this.vectorSource.getFeatures().length > 0) {
              const extent = this.vectorSource.getExtent();

              if (extent) {
                this.map.getView().fit(extent!, { padding: [50, 50, 50, 50], maxZoom: 22, duration: 800 });
              }
            }

          })
          .catch(err => {
            console.warn('Errore apply map style:', err);
            // aggiungi comunque vector layer se apply fallisce
            const vectorLayer = new VectorLayer({ source: this.vectorSource });
            this.map.addLayer(vectorLayer);
          });

      });
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  onFieldDataChanged(e: any) {
    if (e.dataField === "constructionSiteCode") {

      let contructionSiteFilter = e.value;
      while (contructionSiteFilter?.endsWith("000")) {
        contructionSiteFilter = contructionSiteFilter.substring(0, contructionSiteFilter.length - 3);
      }

      const faseEditor = e.component.getEditor("workingPhaseCode");

      if (faseEditor) {
        const dataSource = faseEditor.getDataSource();
        dataSource.filter(["ConstructionSiteCode", "startswith", contructionSiteFilter]);
        dataSource.reload();
      }

      if (this.clock) {
        this.clock.workingPhaseCode = null;
      }
    }
  }

  Forward() {
    const result = this.form.instance.validate();

    if (result.isValid && this.clock != null) {
      this.clock.manual = true;

      if (this.clock.clockId && this.clock.clockId > 0) {
        this.restApi.putClock(this.clock).pipe(first()).subscribe({
          next: () => {
            this.router.navigate(['/clocks-admin']);
          }
        });  
      }
      else {
        this.restApi.postClock(this.clock).pipe(first()).subscribe({
          next: () => {
            this.router.navigate(['/clocks-admin']);
          }
        });  
        
      }
      
    }
  }

  Back() {
    const result = confirm("<i>Sei sicuro?</i><br>I dati inseriti andranno persi", "Conferma Abbandono");
    result.then((dialogResult) => {
      if (dialogResult) {
        // Torno all'indice
        this.router.navigate(['/clocks-admin']);
      }
    });
  }
}
